import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const image = async (formData: FormData): Promise<string> => {
  const response = await apiLoaderInstance.post(URL.UPLOAD_IMAGE, formData);
  return response.data.data.url;
};
